/**
 * Turn a comma seperated list to an array,
 * always return a blank array if the string is null / empty
 * @param {string} commaSeperatedValue
 */
const commaSeperatedValueToArray = commaSeperatedValue => {
  // if the value is an array then just return the array
  // if there is only one string value with no comma then return that value in an array
  // if there are more than one values with a comma then split into an array of multiple values
  // if commaSeperatedValue is null then return an empty array
  if (Array.isArray(commaSeperatedValue)) {
    return commaSeperatedValue;
  } else {
    if (commaSeperatedValue) {
      if (commaSeperatedValue.includes(",")) {
        return commaSeperatedValue.split(", ");
      } else {
        return [commaSeperatedValue];
      }
    } else {
      return [];
    }
  }
};

export default commaSeperatedValueToArray;
